import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import IconSwitch from '../IconSwitch';

import './InputPasswordField.css';

/**
 * InputPasswordField for any form.
 */

class InputPasswordField extends React.Component {
	constructor(props) {
	    super(props);
	    this.onFocus = this.onFocus.bind(this);
	    this.onBlur = this.onBlur.bind(this);
	    this.onToggle = this.onToggle.bind(this);
	    this.state = {isFocused: false, isFilled: false, showPass: false, fieldType: 'password'};
	}
	componentDidMount() {
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
	}
	onFocus(e) {
		this.setState({isFocused: true});
	}
	onBlur(e) {
		this.setState({isFocused: false});
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
	}
	onToggle(e) {
		this.setState({fieldType: (this.state.fieldType==='password'?'text':'password'), showPass: !this.state.showPass});
	}
    render () {
    	const id = uniqueId('input_'); 
		const getIcon = this.props.icon!==null?this.props.icon:<div></div>;
		const classNames = (this.state.isFocused?"focused ":"")+(this.state.isFilled?"filled ":"")+(getIcon!==null?"has-icon ":"")+"inputfieldpw inputfield"
		return (
			<div className={classNames}>
				<input autoCapitalize="off" autoCorrect="off" autoComplete="off" id={id} {...this.props} type={this.state.fieldType} onFocus={this.onFocus} onBlur={this.onBlur} ref={(input) => { this.fieldInput = input; }}  />
				<label htmlFor={id}>{this.props.label}</label>
				{getIcon}
				<IconSwitch active={this.state.showPass} color="rgba(255,255,255,0.5)" colorActive="rgba(255,255,255,0.8)" size="18px" onClick={e => this.onToggle(e)} />
			</div>
		)
    }

}
InputPasswordField.propTypes = {
	/** InputPasswordField Icon */
	icon: PropTypes.node,
	/** InputPasswordField Label */
	label: PropTypes.string.isRequired,
}


InputPasswordField.defaultProps = {
  type: "text"
}

export default InputPasswordField;


// WEBPACK FOOTER //
// ./src/components/atoms/InputPasswordField/InputPasswordField.js